export const SET_PAGE = 'PortalNavContext.SET_PAGE';
export const SET_PATIENT_NUMBER = 'PortalNavContext.SET_PATIENT_NUMBER';
export const SET_LISTING_FILTERS = 'PortalNavContext.SET_LISTING_FILTERS';
export const SET_LOADING = 'PortalNavContext.SET_LOADING';

export const LISTING = 'LISTING';
export const PATIENT = 'PATIENT';
